import { useLanguage } from '@/contexts/LanguageContext';
import heroImg1 from '@/assets/hero-salzburg.jpg?format=webp&quality=80';
import heroImg2 from '@/assets/hero-fleet.png?format=webp&quality=80';
import heroImg3 from '@/assets/hero-taxi-night.jpg?format=webp&quality=80';
import { Phone, MessageCircle, Calendar } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import LocalizedLink from '@/components/LocalizedLink';
import { useState, useEffect } from 'react';

const heroImages = [heroImg1, heroImg2, heroImg3];

const HeroSection = () => {
  const { t } = useLanguage();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <AnimatePresence>
          <motion.img
            key={currentIndex}
            src={heroImages[currentIndex]}
            alt={['Salzburg Altstadt panoramic view – Taxi Salzburg premium transfer service', 'Taxi Salzburg premium fleet – Mercedes E-Class and V-Class vehicles', 'Night taxi transfer in Salzburg – 24/7 airport and city taxi service'][currentIndex]}
            className="absolute inset-0 w-full h-full object-cover"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 2, ease: "easeInOut" }}
          />
        </AnimatePresence>
        <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, hsla(0,0%,0%,0.3), hsla(0,0%,0%,0.45))' }} />
      </div>

      <div className="relative z-10 container text-center py-20">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary/20 text-primary text-sm font-medium mb-6 backdrop-blur-sm border border-primary/30">
            ⭐ Taxi Salzburg — {t.features.service247}
          </span>
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-secondary-foreground mb-6 leading-tight max-w-5xl mx-auto">
            {t.hero.title}
          </h1>
          <p className="text-lg md:text-xl text-secondary-foreground/80 max-w-2xl mx-auto mb-10">
            {t.hero.subtitle}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
            <LocalizedLink to="/booking" className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-gradient-gold font-semibold text-primary-foreground shadow-gold hover:scale-105 transition-transform text-lg">
              <Calendar className="w-5 h-5" />
              {t.hero.cta}
            </LocalizedLink>
            <a href="https://wa.me/436606521071" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-8 py-4 rounded-full border-2 border-green-500 text-green-400 hover:bg-green-500 hover:text-secondary-foreground transition-all font-semibold text-lg">
              <MessageCircle className="w-5 h-5" />
              {t.hero.whatsapp}
            </a>
          </div>
          <a href="tel:+436606521071" dir="ltr" className="inline-flex items-center gap-2 text-secondary-foreground/60 hover:text-primary transition-colors">
            <Phone className="w-4 h-4" /> +43 660 6521071
          </a>
        </motion.div>
      </div>

    </section>
  );
};

export default HeroSection;
